import React from 'react';
import { motion } from 'framer-motion';

function LoadingSpinner({ size = 'lg', className = '' }) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <motion.div
        className={`${sizeClasses[size]} rounded-full border-2 border-gray-300 border-t-purple-600`}
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      />
    </div>
  );
}

export function FullPageLoader() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center">
      <div className="text-center">
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-2xl flex items-center justify-center mb-4 mx-auto"
        >
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M8 12h16v2H8v-2zm0 4h16v2H8v-2zm0 4h10v2H8v-2z" fill="white"/>
            <circle cx="22" cy="10" r="2" fill="white"/>
          </svg>
        </motion.div>
        <LoadingSpinner size="xl" />
        <p className="text-gray-300 mt-4">Loading Spacebook...</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;